import { compose } from 'recompose'
import ValuePropositionBig from './ValuePropositionBig'

export default compose()(ValuePropositionBig)
